import { IF, NO, UITextView, UIView } from "uicore-ts"
import { RHFont } from "./Utils_slop/RHDesignTokens"
import { RHQuillSnowCSS } from "./Utils_slop/RHQuillSnowCSS"
import { RHTextSanitizer } from "./Utils_slop/RHTextSanitizer"


UIView.injectCSS(RHQuillSnowCSS, "RHQuillSnowStyles")
UIView.injectCSS(`
.RHRichTextDisplay.ql-editor { padding: 0; overflow: visible; font-family: ${RHFont.familyBase}; }
`, "RHRichTextDisplayStyles")


export class RHRichTextView extends UITextView {

    constructor(elementID?: string) {
        super(elementID, "div");
        (this as RHRichTextView).configureWithObject({
            isSingleLine: NO,
            style: { overflow: "visible" },
            textElementView: {
                style: {
                    display: "block",
                    overflow: "visible",
                    overflowWrap: "anywhere",
                    textOverflow: "clip",
                    webkitLineClamp: "",
                    webkitBoxOrient: ""
                }
            }
        })
    }


    configureWithText(text: string, format?: "plaintext" | "html") {
        const isHTML = format === "html"
        this.textElementView.viewHTMLElement.classList.toggle("ql-editor", isHTML)
        this.textElementView.viewHTMLElement.classList.toggle("RHRichTextDisplay", isHTML)
        this.textElementView.configureWithObject({
            style: { whiteSpace: IF(isHTML)(() => "normal").ELSE(() => "pre-wrap") }
        })
        this.text = IF(isHTML)(
            () => RHTextSanitizer.sanitizedHTML(text)
        ).ELSE(
            () => RHTextSanitizer.escapedHTML(text)
        )
        this.setUseFastMeasurement(NO)
        this.setNeedsLayoutUpToRootView()
    }

}
